(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brat-bundle"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".brat-button");
  const featuredBlocks = document.querySelectorAll(".brat-featured");

  buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
      buttons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      featuredBlocks.forEach((block) => {
        if (block.dataset.index === index.toString()) {
          block.style.display = "flex";
        } else {
          block.style.display = "none";
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
